 import project1 from '../assets/img1.jpg';
 import project2 from '../assets/img2.jpg';
 import project3 from '../assets/img3.jpg';
 import project4 from '../assets/img4.jpg';
 import project5 from '../assets/img5.jpg';
 import project6 from '../assets/img6.jpg';
 import profile from '../assets/background.png';
 import leetcode from '../assets/leetcode.png';
 import geeksforgeeks from '../assets/geeksforgeeks.png';



 export default {
    project1,project2,project3,project4,project5,project6,profile,geeksforgeeks,leetcode
  };
  